




























































import { Vue, Component, Prop } from 'vue-property-decorator';
import { studentModule } from '@/store/modules/entities/student.module';
import { masterModule } from '@/store/modules/entities/master.module';
import { studentAllCompetencyModule } from '@/store/modules/frames/student-all-competency.module';
import { InterviewNaviCompetency } from '@/models/interview-navi/competency';
import { StudentCompetencyGrowth } from '@/models/student/student-competency-growth';
import GStudentRecordCompetencyScoreTransition from '@/views/GStudentRecord/GStudentRecordCompetencyScoreTransition.vue';
import GTopicSubject from '@/components/GTopicSubject.vue';
import GTextView from '@/components/GTextView.vue';
import GCompetencyLabel from '@/components/GCompetencyLabel.vue';
import GLoading from '@/components/GLoading.vue';
import { ScoreUtils } from '@/utils/score.utils';

@Component({
  name: 'GStudentRecordInterviewNavi',
  components: { GCompetencyLabel, GTextView, GTopicSubject, GStudentRecordCompetencyScoreTransition, GLoading },
  computed: {},
  methods: {},
})
export default class GStudentRecordInterviewNavi extends Vue {
  mounted() {}

  getScoreProgressStatusString(count: number, isNew: boolean): string {
    return ScoreUtils.toStringScoreProgressStatus(count, isNew);
  }

  get studentGrowthCompetenciesTop3(): StudentCompetencyGrowth[] {
    if (this.studentCompetencyGrowth.length > 0) {
      return this.studentCompetencyGrowth.slice().filter((scg: StudentCompetencyGrowth) => {
        if (scg.latestCourseResult.competencyScore > 0 && scg.lastCourseResult.competencyScore > 0 && !scg.isCompetencyScoreLess) {
          return scg;
        }
      }).sort((a: StudentCompetencyGrowth, b: StudentCompetencyGrowth) => {
        return a.scoreDiff < b.scoreDiff ? 1 : -1;
      }).slice(0, 3);
    }
  }

  get studentGrowthCompetenciesWorst3(): StudentCompetencyGrowth[] {
    if (this.studentCompetencyGrowth.length > 0) {
      return this.studentCompetencyGrowth.slice().filter((scg: StudentCompetencyGrowth) => {
        if (scg.latestCourseResult.competencyScore > 0 && scg.lastCourseResult.competencyScore > 0 && scg.isCompetencyScoreLess) {
          return scg;
        }
      })
      .sort((a: StudentCompetencyGrowth, b: StudentCompetencyGrowth) => {
          return a.scoreDiff > b.scoreDiff ? 1 : -1;
      }).slice(0, 3);
    }
  }

  getInterviewNaviCompetency(id: number): InterviewNaviCompetency {
    return this.interviewNaviCompetencies.find((compe: InterviewNaviCompetency) => {
      return compe.competencyID === id;
    });
  }

  get interviewNaviCompetencies(): InterviewNaviCompetency[] {
    return masterModule.interviewNaviCompetencies;
  }

  get studentCompetencyGrowth(): StudentCompetencyGrowth[] {
    return studentAllCompetencyModule.studentCompetencyGrowth;
  }

  /**
   * コンピテンシー成長のデータ
   * コンピテンシー毎に過去のスコアが全て保持されているが（courseResults）
   * スコアが2以上記録されているコンピテンシーが存在するか => 2つ以上記録 = 2回以上受検している
   */
  get isExistTargetScore(): boolean {
    if (this.studentCompetencyGrowth.length > 0) {
      const result = this.studentCompetencyGrowth.slice().filter((scg: StudentCompetencyGrowth) => {
        if (scg.courseResults.length > 1) return scg;
      });
      return result.length > 0 ? true : false;
    }
    return false;
  }
}
